import { useState } from "react";
import UpToUpdateFotoLicencia from "./upToUpdateFoto";
import ErrorModal from "../../../components/modals/errorModal";
import { CameraIcon, FileUploadIcon } from "../../../components/icons/SvgIcons";

function CargarFotoLicencia({ closeCargarFoto, openTakeFotoToUpdate, id, onLicenciaActualizada }) {

  const [imagen, setImagen] = useState(null);
  const [errorModal, setErrorModal] = useState({ show: false, message: "" });
  const openErrorModal = (message) => setErrorModal({ show: true, message });
  const closeErrorModal = () => setErrorModal({ show: false, message: "" });

  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
  const [preview, setPreview] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    // Validar tipo de archivo (solo imágenes)
    if (!file.type.startsWith("image/")) {
      openErrorModal("Por favor, selecciona un archivo de imagen válido.");
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      openErrorModal("La imagen es demasiado grande. Selecciona una de menos de 5MB.");
      return;
    }

    // Crear vista previa
    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);

    // Guardar el archivo en el estado
    setImagen(file);

  };

  const handleBack = () => {
    setImagen(null);
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 "
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          closeCargarFoto();
        }
      }}
    >
      {!imagen ? (
        <div
          className="w-[20rem] sm:w-[30rem] px-1 py-1 bg-white rounded-xl flex flex-col justify-center  gap-6 mx-5 overflow-y-auto my-[2rem]"
          onClick={(e) =>
            e.stopPropagation()
          } /* Evita que el clic dentro lo cierre */
        >
          <div className="my-[1rem]  flex-col justify-start items-start gap-3 inline-flex mx-[1rem]">
            <button
              onClick={openTakeFotoToUpdate}
              className="self-stretch px-4 py-7 bg-white rounded-lg border border-[#c5dfff] justify-start items-center gap-2.5 inline-flex"
            >
              <div className="w-[49px] h-[49px] relative">
                <CameraIcon className="size-18 stroke-[#0477ad]" />
              </div>
              <div className="flex-col justify-start items-start gap-1 inline-flex">
                <div className="text-[#0477ad] text-lg font-bold font-inter">
                  Tomar foto
                </div>
                <div className="text-[#687073] text-start text-sm font-normal font-inter">
                  Capturar una foto de la licencia
                </div>
              </div>
            </button>
            <label
              for="file-upload"
              htmlFor="file-upload"
              className="self-stretch px-4 py-7 bg-white rounded-lg border border-[#c5dfff] justify-start items-center gap-2.5 inline-flex cursor-pointer"
            >
              <div className="w-[49px] h-[49px] relative">
                <FileUploadIcon className="size-18 stroke-[#0477ad]" />
              </div>
              <div className="flex-col justify-start items-start gap-1 inline-flex">
                <div className="text-[#0477ad] text-lg font-bold font-inter">
                  Subir foto
                </div>
                <div className="text-[#687073] text-sm font-normal font-inter">
                  Cargar una foto del dispositivo
                </div>
              </div>

              <input
                type="file"
                id="file-upload"
                className="hidden"
                onChange={handleFileChange}
              />
            </label>
          </div>
        </div>
      ) : (
        <UpToUpdateFotoLicencia imagen={imagen} preview={preview} handleBack={handleBack} id={id} onLicenciaActualizada={onLicenciaActualizada}/>
      )}
      {errorModal.show && (
        <ErrorModal
          closeErrorModal={closeErrorModal}
          message={errorModal.message}
        />
      )}
    </div>
  );
}

export default CargarFotoLicencia;
